export default __webpack_public_path__ + "static/media/Ies_LogoColorIES.abf00ec8.png";